export const LEGACY_DATE = {
  allDates          : '*',
  dayFirstFormat    : 'dd/mm/yyyy',
  filterMaxlength   : 50,
  looseViewPattern  : /(\d{1,2})\/(\d{1,2})\/(\d{4})/,
  modelPattern      : /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/,
  monthPattern      : /(\d{1,2})\/(\d{4})/,
  monthPickerOptions: {
    format     : 'mm/yyyy',
    minViewMode: 'months',
    viewMode   : 'months'
  },
  monthPickFormat   : 'MM/YYYY',
  monthPickOffsetDay: 7,
  pickerOptions     : {
    autoclose: true,
    todayBtn : 'linked'
  },
  pickOffset : 60 * 60 * 1000,
  viewPattern: /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
  yearPattern: /(\d{4})/
};
